import { render, staticRenderFns } from "./DetalhesMovimentacao.vue?vue&type=template&id=da7b2906&scoped=true"
import script from "./DetalhesMovimentacao.vue?vue&type=script&lang=js"
export * from "./DetalhesMovimentacao.vue?vue&type=script&lang=js"
import style0 from "./DetalhesMovimentacao.vue?vue&type=style&index=0&id=da7b2906&prod&lang=scss"
import style1 from "./DetalhesMovimentacao.vue?vue&type=style&index=1&id=da7b2906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7b2906",
  null
  
)

export default component.exports